import { useMemo } from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  UserOutlined,
  PhoneOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';

export const useOutcomeRender = () => {
  return useMemo(() => {
    return (outcome: string) => {
      const outcomeConfigs: {
        [key: string]: {
          icon: React.ReactNode;
          text: string;
          bgColor: string;
          textColor: string;
          borderColor: string;
        };
      } = {
        INTERESTED: {
          icon: <CheckCircleOutlined />,
          text: 'Interested',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        },
        NOT_INTERESTED: {
          icon: <CloseCircleOutlined />,
          text: 'Not Interested',
          bgColor: '#fff2f0',
          textColor: '#cf1322',
          borderColor: '#ffb3b3',
        },
        NEED_TIME: {
          icon: <ClockCircleOutlined />,
          text: 'Need Time',
          bgColor: '#fff7e6',
          textColor: '#d48806',
          borderColor: '#ffd666',
        },
       
        NO_RESPONSE: {
          icon: <MinusCircleOutlined />,
          text: 'No Response',
          bgColor: '#f5f5f5',
          textColor: '#595959',
          borderColor: '#d9d9d9',
        },
        NOT_REACHABLE: {
          icon: <PhoneOutlined />,
          text: 'Not Reachable',
          bgColor: '#fff2f0',
          textColor: '#cf1322',
          borderColor: '#ffb3b3',
        },
        FOLLOW_UP: {
          icon: <RedoOutlined />,
          text: 'Follow up',
          bgColor: '#e6f7ff',
          textColor: '#1890ff',
          borderColor: '#91d5ff',
        },
        MISSED: {
          icon: <MinusCircleOutlined />,
          text: 'Missed',
          bgColor: '#f5f5f5',
          textColor: '#595959',
          borderColor: '#d9d9d9',
        },
        GOOD: {
          icon: <CheckCircleOutlined />,
          text: 'Good',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        },
        BAD: {
          icon: <CloseCircleOutlined />,
          text: 'Bad',
          bgColor: '#fff2f0',
          textColor: '#cf1322',
          borderColor: '#ffb3b3',
        },
        CONFIRM: {
          icon: <CheckCircleOutlined />,
          text: 'Confirm',
          bgColor: '#f6ffed',
          textColor: '#389e0d',
          borderColor: '#b7eb8f',
        },
      };

      const config = outcomeConfigs[outcome] || {
        text: outcome || '',
        bgColor: '#fafafa',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <>
          {config.icon ? (
            <Tag
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontWeight: 500,
                padding: '4px 8px',
                borderRadius: '6px',
                lineHeight: '1.2',
                backgroundColor: config.bgColor,
                color: config.textColor,
                border: `1px solid ${config.borderColor}`,
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {config.icon || ''}
              </span>
              <span>{config.text}</span>
            </Tag>
          ) : (
            <span className="text-gray-500">-</span>
          )}
        </>
      );
    };
  }, []);
};
